var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 74,
    viewBox: "0 0 98 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7151 34.3656C88.949 81.2096 56.8849 73.8982 50.2914 73.1558C18.3382 69.558 -1.3958 65.3982 0.0771051 36.2784C5.67365 6.59629 15.6886 -0.000275324 50.2914 8.61851e-09C72.4536 0.000176352 101.172 15.8904 97.7151 34.3656Z",
    fill: "#F57171",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_1036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 8,
    width: 55,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 54.2074,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_1036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1039 55.4793C46.4399 55.4793 43.9438 54.9866 41.6156 54.0013C39.2875 53.0161 37.2576 51.6769 35.526 49.9839C33.7944 48.2909 32.4248 46.3062 31.4171 44.0299C30.4093 41.7536 29.9055 39.3132 29.9055 36.7085C29.9055 34.1038 30.4093 31.6633 31.4171 29.387C32.4248 27.1107 33.7944 25.1261 35.526 23.433C37.2576 21.74 39.2875 20.4009 41.6156 19.4156C43.9438 18.4303 46.4399 17.9377 49.1039 17.9377C51.7679 17.9377 54.264 18.4303 56.5921 19.4156C58.9203 20.4009 60.9501 21.74 62.6818 23.433C64.4134 25.1261 65.783 27.1107 66.7907 29.387C67.7984 31.6633 68.3023 34.1038 68.3023 36.7085C68.3023 39.3132 67.7984 41.7536 66.7907 44.0299C65.783 46.3062 64.4134 48.2909 62.6818 49.9839C60.9501 51.6769 58.9203 53.0161 56.5921 54.0013C54.264 54.9866 51.7679 55.4793 49.1039 55.4793ZM55.8191 45.6012L58.1992 43.2741L50.7978 36.0375V25.6668H47.41V37.3795L55.8191 45.6012ZM34.9961 14.3789L37.3763 16.7061L28.6458 25.2421L26.2656 22.9149L34.9961 14.3789ZM63.2117 14.3789L71.9422 22.9149L69.5619 25.2421L60.8315 16.7061L63.2117 14.3789ZM49.1039 52.1668C53.4937 52.1668 57.2263 50.6634 60.3016 47.6567C63.3768 44.65 64.9144 41.0006 64.9144 36.7085C64.9144 32.4164 63.3768 28.767 60.3016 25.7602C57.2263 22.7535 53.4937 21.2501 49.1039 21.2501C44.714 21.2501 40.9815 22.7535 37.9062 25.7602C34.831 28.767 33.2934 32.4164 33.2934 36.7085C33.2934 41.0006 34.831 44.65 37.9062 47.6567C40.9815 50.6634 44.714 52.1668 49.1039 52.1668Z",
    fill: "#F57171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortRecording);
export default __webpack_public_path__ + "static/media/short_recording.6e8fad1fe6fff70046446e12a75e859f.svg";
export { ForwardRef as ReactComponent };